import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { SendEmailInterface } from './interfaces/sendmail_response.interface';

type CallbackFunction = (response: SendEmailInterface | null, error: SendEmailInterface | null) => void;

@Injectable({
  providedIn: 'root'
})
export class MailService {

  private http = inject(HttpClient);

  API_URL: string = environment.apiURL;

  constructor() { }

  sendEmail(name: string, email: string, description: string, callback: CallbackFunction) {
    const body = JSON.parse('{"name":"' + name + '", "email":"' + email + '", "description":"' + description + '"}');
    const observer = this.http.post<SendEmailInterface>(this.API_URL + "/mail", body, { observe: 'response' });

    observer.subscribe(
      (response) => {
        const serviceResponse: SendEmailInterface = { message: response.body?.message };
        callback(serviceResponse, null);
      },
      (error) => {
        const serviceError: SendEmailInterface = { message: error.error.message };
        callback(null, serviceError);
      }
    );
  }
}
